import React from "react";
import { User } from "../models/messages";
import UserAvatar from "./UserAvatar";

interface Props {
  users: Array<User>;
}

export default function ConnectedUsers(props: Props) {
  const { users } = props;
  const connectedUsers = users.filter((user) => user.connected);

  return (
    <div className="mt-3 p-2">
      <h5 className="text-light">Connected Users</h5>
      <div className="d-flex  align-items-center justify-items-start">
        <div className="d-flex flex-wrap align-items-between justify-items-center">
          {connectedUsers.map(({ avatar, id }) => (
            <UserAvatar avatarDef={avatar} key={id} />
          ))}
        </div>{" "}
      </div>
    </div>
    // Todo: Show invite users message if no other users are connected...
  );
}
